import Heading from "@elements/Typography/Heading";
import { ReactElement, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export type MainBlockProps = Readonly<{
  children: ReactNode;
  className?: string;
  testId?: string;
  showTitle?: boolean;
  sectionName?: string;
  pageName: string;
}>;

export default function MainBlock({
  children,
  className,
  pageName,
  testId = "main-block",
  showTitle = true,
}: MainBlockProps): ReactElement {
  return (
    <div
      className={twMerge("w-full lg:w-[860px] lg:pr-md", className)}
      data-testid={testId}
    >
      {showTitle && (
        <Heading className="text-3md lg:text-lg font-bold font-primary">
          {pageName && pageName}
        </Heading>
      )}
      {children}
    </div>
  );
}
